import React from "react";
import moment from "moment";
import { colour } from "../style/base-theme";

export default function AxisLabel(props) {
  const {
    payload: { value },
    textAnchor,
    y,
    x,
    data,
    index,
    fontSize
  } = props;

  const today = moment();
  let timestamp = moment.unix(value);
  let day;

  if (today.isSame(timestamp, "day")) {
    day = "Today";
  } else {
    day = moment
      .unix(value)
      .format("ddd")
      .charAt(0);
  }

  // const day = moment
  //   .unix(value)
  //   .format("ddd")
  //   .charAt(0);

  let axisValue =
    data.time_series[index].appliance &&
    data.time_series[index].appliance[fontSize].toFixed(2);

  let axisValueUnit = "";
  switch (fontSize) {
    case "cost":
      axisValue = `${data.currency_unit}${axisValue}`;
      break;
    case "duration":
      axisValue = `${axisValue}${data.time_unit.charAt(0)}`;
      break;
    case "consumed":
      axisValue = `${axisValue}${data.energy_unit}`;
      break;
    default:
      axisValue = "";
      break;
  }

  return (
    <text
      fill={colour.grey[400]}
      fontWeight={600}
      fontSize={14}
      textAnchor={textAnchor}
    >
      <tspan x={x} y={y + 12}>
        {day}
      </tspan>
      <tspan x={x} y={y + 27} fontSize={12} fill={colour.brand.blue}>
        {axisValue}
      </tspan>
    </text>
  );
}
